import { createRoute } from '@tanstack/react-router';

import { FileViewer } from '../../features/file/file-viewer';
import { signInRoute } from '../signin';

export const fileViewerRoute = createRoute({
  getParentRoute: () => signInRoute,
  path: '/file/$fileId',
  component: FileViewer,
});
